import React, { useEffect, useState } from 'react'
import { IconButton, Box } from '@mui/material'
import {
  ReportHeading,
  LoaderWrapper,
  D3ForceDirectedTreeV2,
  ReportOuterWrapper,
} from '../../../../components'
import ReportsService from '../../../../services/reports.service'
import { useUpdateLhs, useReactQuery } from '../../../../hooks'
import { Refresh, closeMini, edit, DoubleArrow } from '../../../../assets/images/icons'
import { getObjectAsArray } from '../../../../util'
import { ROLES_MM_PRIMARY } from '../../../../constants'
import ReportEditInsights from './reportEditInsights'
import { useGlobalStore } from '../../../../store'
import {
  OuterWrapper,
  InnerWrapper,
  CustomInsightsHtmlWrapper
} from './style'

const ReportFactorInterLinkage = (props) => {
  const [loading, setLoading] = useState(false)
  const [state, setState] = useState([])
  const [statePreview, setStatePreview] = useState([])
  const [statePPT, setStatePPT] = useState([])
  const { updateSubLhsApiLoaded } = useUpdateLhs()
  const [reportExcelData, setReportExcelData] = useState()
  const [showExploreGraph, setShowExploreGraph] = useState(true)
  // const [clickedIndex, setClickedIndex] = useState(null)
  const [editIndex, setEditIndex] = useState(null)
  // const [showMenu, setShowMenu] = useState(null)
  const [colorPallet, setColorPallet] = useState({})
  const { user, projectIdValue } = useGlobalStore()
  const [modalOpened, setModalOpened] = useState(false)
  const [showLinkagePopup, setShowLinkagePopup] = useState(true)
  const [graphLegends, setGraphLegends] = useState([])
  const [eventCount, setEventCount] = useState(1)
  const [scaleFactorWeight, setScaleFactorWeight] = useState(true)
  const [customInsightsHtmlData, setCustomInsightsHtmlData] = useState(null)
  const [pptData, setPptData] = useState(null) // NOTE: CONFIGURATION FOR GENERATING NATIVE PPT.

  const getPercentage = (value, finalResp) => {
    const minSize = Math.min(...finalResp.map((d) => d.FactorWeight))
    let maxSize = Math.max(...finalResp.map((d) => d.FactorWeight))
    if (maxSize === minSize) maxSize = minSize + 5 // to avoid division by zero

    const percentageMin = 50
    const percentageMax = 100

    const mapToRange = (value, inMin, inMax, outMin, outMax) => {
      const ratio = (value - inMin) / (inMax - inMin)
      return outMin + ratio * (outMax - outMin)
    }

    const percentage = mapToRange(value, minSize, maxSize, percentageMin, percentageMax)
    return percentage
  }

  const getUniqueData = (arr) => {
    let outputArray = arr.filter(function (v, i, self) {
      return i == self.indexOf(v)
    })
    return outputArray
  }

  const generatePptDataFunc = (respData) => {
    const pptIsHighlightedArray1 = respData.filter((f) => f.IsHighlighted)
    const pptIsHighlightedArray2 = []
    const pptIsHighlightedArray3 = []

    if (pptIsHighlightedArray1.length === 0) {
      console.log(
        'Check1',
        respData.map((d, i) => ({ index: i, Factor: d.Factor, IsHighlighted: d.IsHighlighted }))
      )
      console.log(
        'NOTE: In FactorInterLinkage ========> isHighlighted is false, hence not showing in ExportToPPT. '
      )
    }

    for (let a = 0; a < pptIsHighlightedArray1.length; a++) {
      const factorLinkageArray = getObjectAsArray(
        pptIsHighlightedArray1[a].FactorLinkages.FactorLinkage
      )
      pptIsHighlightedArray2.push([])
      const tempSource = []

      for (let b = 0; b < factorLinkageArray.length; b++) {
        if (tempSource.includes(factorLinkageArray[b].LinkedFactor)) {
          continue
        }
        // const factorGroup = respData.find(f => f.Factor === factorLinkageArray[b].LinkedFactor ).FactorGroup
        const factorGroup =
          respData.filter((f) => f.Factor === factorLinkageArray[b].LinkedFactor)?.FactorGroup || []
        tempSource.push(factorLinkageArray[b].LinkedFactor)
        pptIsHighlightedArray2[a].push({
          ...pptIsHighlightedArray1[a],
          FactorGroup: factorGroup,
          source: factorLinkageArray[b].LinkedFactor,
          // LinkedFactorWeight: factorLinkageArray[b].LinkedFactorWeight,
          FactorWeight:
            factorLinkageArray[b].LinkedFactorWeight || pptIsHighlightedArray1[a].FactorWeight,
          // target: factorLinkageArray[b].LinkedFactor,
          targetValue: factorLinkageArray[b].LinkageWeight,
          targetInsights: factorLinkageArray[b].Insights,
          targetId: factorLinkageArray[b].FactorLinkageId,
        })
      }

      pptIsHighlightedArray2[a].unshift({
        ...pptIsHighlightedArray1[a],
        source: pptIsHighlightedArray1[a].Factor,
        target: pptIsHighlightedArray1[a].Factor,
        targetValue: pptIsHighlightedArray1[a].FactorWeight,
        targetInsights: ' ',
        targetId: pptIsHighlightedArray1[a].InsightsElementId,
      })
    }

    ////////////////////////////////////////////////

    for (let d = 0; d < pptIsHighlightedArray2.length; d++) {
      const finalResp = pptIsHighlightedArray2[d]
      const category = finalResp.map((d) => ({ id: d.FactorGroup }))
      const sourceArray = finalResp.map((r) => r.source)
      const nodes = finalResp.map((d, i) => ({ id: i, name: d.source }))

      const links = finalResp.map((d, i) => {
        return {
          id: i,
          source: sourceArray.indexOf(d.source),
          // source: d.source,
          category: d.FactorGroup,
          // size: d.FactorWeight + 45,
          // size: calculateSize(d, 45),
          size: getPercentage(d.FactorWeight, finalResp),
          value: d.targetValue,
          target: 0,
        }
      })

      const linksDetails = finalResp.map((d, i) => {
        return {
          id: i,
          insightsElementId: d.InsightsElementId,
          isHighlighted: d.IsHighlighted,
          source: d.source,
          sourceArray: getText(d.source),
          category: d.FactorGroup,
          // size: d.FactorWeight + 40,
          // size: calculateSize(d, 40),
          size: getPercentage(d.FactorWeight, finalResp),

          value: d.targetValue,
          target: 0, // sourceArray.indexOf(d.target),
          targetStr: d.target,
          targetInsights: d.targetInsights,
          targetId: d.targetId,
          clicked: i === 0, // false,
          clickedIndex: 0,
          factorType: d.factorType,
          isRepeated: false,
          rest: d,
        }
      })

      const linksDetailsTargets = generateTargetArrayList(linksDetails)
      pptIsHighlightedArray3.push({ nodes, links, linksDetails, category, linksDetailsTargets })
    }

    setStatePPT(pptIsHighlightedArray3)
  }

  const generateTargetArrayList = (respData) => {
    const parentArray = respData.filter((f) => f.factorType === 'parent')
    const childArray = respData.filter((f) => f.factorType === 'child')
    const finalArray = []

    for (let i = 0; i < parentArray.length; i++) {
      finalArray.push([])
      for (let j = 0; j < respData.length; j++) {
        if (parentArray[i].id === respData[j].id) {
          finalArray[i].push(respData[j].id)
        } else if (parentArray[i].id === respData[j].target) {
          finalArray[i].push(respData[j].id)
        }
      }

      for (let j = 0; j < childArray.length; j++) {
        if (parentArray[i].source === childArray[j].source) {
          finalArray[i].push(childArray[j].id)
        }
      }

      const factorLinkageArray = getObjectAsArray(
        parentArray[i].rest.FactorLinkages.FactorLinkage
      ).map((d) => d.LinkedFactor)
      for (let j = 0; j < parentArray.length; j++) {
        if (factorLinkageArray.includes(parentArray[j].source)) {
          finalArray[i].push(parentArray[j].id)
        }
      }
    }

    return finalArray
  }

  const getText = (s = '') => {
    s = s.trim();
    const parts = s.split(/\s+/);
    const n = parts.length;
    if (n === 1) {
        return [parts[0], ""];
    } else if (n === 2) {
        return [parts[0], parts[1]];
    } else if (n === 3) {
        // brand = first word, model = last two
        return [parts[0], parts.slice(1).join(" ")];
    } else {
        // n >= 4
        // maybe brand = first two, model = rest
        return [parts.slice(0, 2).join(" "), parts.slice(2).join(" ")];
    }
  }


  const getDataFunc = (type = '') => {
    setLoading(true)
    ReportsService.getFactorInterLinkageElement({
      insightsElementId: props.InsightsElementId,
      getLatest: true,
    })
      .then((resp) => {
        const maxFactorWeight = Math.max(...resp.map((d) => d.FactorWeight))
        if (maxFactorWeight < 20 && resp.length > 10) {
          setScaleFactorWeight(true)
        }

        getData(resp)
        if (type === 'saved') {
          refreshFunc()
        }
      })
      .catch((error) => {
        console.log('ERROR : ', error)
      })
      .finally(() => {
        setLoading(false)
      })
  }

  const getData = (resp) => {
    const sourceArray = resp.map((r) => r.Factor)
    let linkedFactorCount = 0

    const finalResp = resp.map((r) => {
      r['target'] = getObjectAsArray(r.FactorLinkages.FactorLinkage)[0].LinkedFactor
      r['targetValue'] = getObjectAsArray(r.FactorLinkages.FactorLinkage)[0].LinkageWeight
      r['targetInsights'] = getObjectAsArray(r.FactorLinkages.FactorLinkage)[0].Insights
      r['targetId'] = getObjectAsArray(r.FactorLinkages.FactorLinkage)[0].FactorLinkageId
      r['factorType'] = 'parent'
      r.FactorLinkages.FactorLinkage = getObjectAsArray(r.FactorLinkages.FactorLinkage)
      return r
    })

    for (let c = 0; c < finalResp.length; c++) {
      const factorLinkageArray = getObjectAsArray(finalResp[c].FactorLinkages.FactorLinkage)
      linkedFactorCount = linkedFactorCount + factorLinkageArray.length
    }

    generatePptDataFunc(finalResp)

    for (let i = 0; i < finalResp.length; i++) {
      if (finalResp.length < linkedFactorCount) {
        const factorLinkageArray = getObjectAsArray(finalResp[i].FactorLinkages.FactorLinkage)
        if (factorLinkageArray?.length > 1) {
          for (let j = 1; j < factorLinkageArray.length; j++) {
            finalResp.push({
              ...finalResp[i],
              target: factorLinkageArray[j].LinkedFactor,
              targetValue: factorLinkageArray[j].LinkageWeight,
              targetInsights: factorLinkageArray[j].Insights,
              targetId: factorLinkageArray[j].FactorLinkageId,
              factorType: 'child',
            })
          }
        }
      }
    }

    const getSize = (apiSize, apiTextArray) => {
      const textMaxLength = Math.max(...apiTextArray.map((t) => t.length)) * 6
      const finalSize = apiSize < textMaxLength ? textMaxLength : apiSize
      return finalSize
    }

    const categoryUniqueList = getUniqueData(finalResp.map((d) => d.FactorGroup))
    const category = finalResp.map((d, i) => {
      return { id: d.FactorGroup }
    })
    const nodes = finalResp.map((d, i) => {
      return { id: i, name: d.Factor }
    })
    const links = finalResp.map((d, i) => {
      return {
        id: i,
        // source: d.Factor,
        source: sourceArray.indexOf(d.Factor),
        category: d.FactorGroup,
        // size: (d.FactorWeight < 50 ) ? 50 : d.FactorWeight, // getSize(d.FactorWeight, getText(d.Factor)),
        // size: d.FactorWeight + 45, // getSize(d.FactorWeight, getText(d.Factor)),
        // size: calculateSize(d, 45),
        size: getPercentage(d.FactorWeight, finalResp),
        value: d.targetValue,
        target: sourceArray.indexOf(d.target),
      }
    })

    const linksDetails = finalResp.map((d, i) => {
      return {
        id: i,
        insightsElementId: d.InsightsElementId,
        isHighlighted: d.IsHighlighted,
        source: d.Factor,
        sourceArray: getText(d.Factor),
        category: d.FactorGroup,
        // size: d.FactorWeight + 40, // getSize(d.FactorWeight, getText(d.Factor)),
        // size: calculateSize(d, 40),
        size: getPercentage(d.FactorWeight, finalResp),
        // size: getSize(d.FactorWeight, getText(d.Factor)),
        value: d.targetValue,
        target: sourceArray.indexOf(d.target),
        targetStr: d.target,
        targetInsights: d.targetInsights,
        targetId: d.targetId,
        // targetInsights: d.FactorLinkages.FactorLinkage[0]?.Insights || '',
        // targetId: d.FactorLinkages.FactorLinkage[0]?.FactorLinkageId,
        clicked: false,
        clickedIndex: null,
        factorType: d.factorType,
        isRepeated: !(sourceArray.indexOf(d.Factor) === i),
        rest: d,
      }
    })

    const legend = {}
    const legends = []
    for (let l = 0; l < categoryUniqueList.length; l++) {
      // const color = ['#C6C6F8', '#F1D794', '#C7D994', '#FCA2B5', '#96E5EE', '#CF92F2']
      const color = [
        '#B0AFEB',
        '#E1C277',
        '#B2C77A',
        '#E9859D',
        '#85D5DE',
        '#B575E6',
        '#3CA3F1',
        '#FFCEDA',
        '#F1743B',
        '#70AAA3',
        '#FFF0B4',
        '#FDAB12',
      ]
      legend[categoryUniqueList[l].replaceAll(' ', '')] = color[l]
      legends.push({
        label: categoryUniqueList[l],
        value: categoryUniqueList[l].replaceAll(' ', ''),
        color: color[l],
      })
    }

    const linksDetailsTargets = generateTargetArrayList(linksDetails)

    setColorPallet(legend)
    setGraphLegends(legends)

    reportExcelDataObjFunc(linksDetails)
    // setState({ nodes, links, linksDetails, category, legend, linksDetailsTargets })
    const stateObject = { nodes, links, linksDetails, category, legend, linksDetailsTargets }
    setState(stateObject)

    if (statePreview.length === 0) {
      setStatePreview({ nodes, links, linksDetails, category, legend })
    }

    updateSubLhsApiLoaded(props)
    setEventCount((p) => p + 1)

    
    setPptData({ heading : '', content : stateObject }) // NOTE: CONFIGURATION FOR GENERATING NATIVE PPT.

    // if(getLatest) {
    //   setTimeout(() => {
    //     setShowExploreGraph(true)
    //   }, 500)
    // }
    setTimeout(() => {
      setEventCount((p) => p + 1)
    }, 500)
  }

  const reportExcelDataObjFunc = (res) => {
    const reportExcelDataObj = []
    for (let r = 0; r < res.length; r++) {
      reportExcelDataObj.push([
        { value: res[r].source },
        // { value: res[r].target },
        { value: res[r].targetStr },
        { value: res[r].value },
      ])
    }
    setReportExcelData(reportExcelDataObj)
  }

  const closeMenu = () => {
    setModalOpened(false)
  }

  const closeEditMenu = () => {
    setEditIndex(null)
  }

  const successEditMenu = () => {
    setEditIndex(null)
    closeMenu()
    setShowExploreGraph(false)
    getDataFunc('saved')
    setCustomInsightsHtmlData(null)
    document.getElementById('output_'+props.type).innerHTML = ''
    // refetch()
  }

  const onChange = ({ type, editIndex }) => {
    if (type === 'edit') {
      setEditIndex(editIndex)
    }
  }

  const modalOpenedHandler = () => {
    setModalOpened(true)
  }

  const refreshFunc = () => {
    setShowExploreGraph(false)
    const linksDetailsData =
      getObjectAsArray(state.linksDetails)?.map((d) => {
        d.clicked = false
        d.clickedIndex = null
        return d
      }) || []
    setState({ ...state, linksDetails: linksDetailsData })

    setTimeout(() => {
      setShowExploreGraph(true)
      setEventCount((p) => p + 1)
    }, 100)
  }

  const onCircleClickedFunc = (data) => {
    document.getElementById('output_'+props.type).innerHTML = ''
    if(data?.length > 0){
      const finalData = data.map(d => {
        return {targetStr:d.targetStr, targetInsights:d.targetInsights, source:d.source, value:d.value}
      })
      const container = document.getElementById('output_'+props.type);

      finalData.forEach(item => {
        const outerDiv = document.createElement('div');
        outerDiv.classList.add('linkagesOuterDiv');
        const headerP = document.createElement('p');
        headerP.classList.add('linkagesHeaderP');
        const labelDiv = document.createElement('div');
        labelDiv.classList.add('linkagesLabelDiv');
        labelDiv.innerHTML = `<b>${item.targetStr}</b><b>${item.source}</b>`;

        const valueDiv = document.createElement('div');
        valueDiv.classList.add('linkagesValueDiv');
        valueDiv.innerText = `${item.value}%`;

        headerP.appendChild(labelDiv);
        headerP.appendChild(valueDiv);
        outerDiv.appendChild(headerP);

        const insightDiv = document.createElement('div');
        insightDiv.classList.add('linkagesInsightDiv');
        insightDiv.innerHTML = item.targetInsights;

        outerDiv.appendChild(insightDiv);
        container.appendChild(outerDiv);
      });
      setCustomInsightsHtmlData(container.innerHTML)
    } else {
      setCustomInsightsHtmlData(null)
    }
  }

  const linkagePopupFunc = (type) => {
    if (type === 'yes') {
      modalOpenedHandler()
    } else if (type === 'no') {
      setShowLinkagePopup(false)
    } else if (type === 'show' && !showLinkagePopup) {
      setShowLinkagePopup(true)
    }
    setEventCount((p) => p + 1)
  }

  useEffect(() => {
    getDataFunc()
  }, [])

  useEffect(() => {
    linkagePopupFunc('no')
  }, [])

  /*
  const onSuccessFunc = (resp) => {
    getDataFunc(resp)
  }

  useEffect(() => {
      if(isSuccess && data?.length) onSuccessFunc(data)
  }, [isSuccess, data])
  */

  return (
    <>
      {(customInsightsHtmlData || eventCount) && pptData && <ReportHeading
        resetInsightHeight={eventCount}
        downloadId={props.type}
        {...props}
        downloadIdData={reportExcelData}
        customInsightsData={customInsightsHtmlData}
        pptData={pptData}
      />}

      {/* // NOTE: CONFIGURATION FOR GENERATING NATIVE PPT. */}
      <ReportOuterWrapper type={props.InsightsElementType}>
        <OuterWrapper id={props.type}>
          <CustomInsightsHtmlWrapper><div id={`output_${props.type}`}></div></CustomInsightsHtmlWrapper>
          {/* <LoaderWrapper loadOnlyApi={props.loadOnlyApi} isLoading={isLoading} isSuccess={isSuccess} isError={isError} error={error}> */}
          <LoaderWrapper loading={loading} loadOnlyApi={props.loadOnlyApi}>
            {ROLES_MM_PRIMARY.includes(user?.UserType) && !projectIdValue?.IsFreezed && !!editIndex && (
              <ReportEditInsights
                data={getObjectAsArray(state.linksDetails)?.[editIndex]}
                onSuccess={successEditMenu}
                onClose={closeEditMenu}
              />
            )}
              
            {!props.isPPTModalActive && (
              <InnerWrapper className='innerWrapper'>
                {eventCount && statePreview?.links?.length > 0 && (
                  <D3ForceDirectedTreeV2
                    onLoadScale={0.9}
                    graphLegends={graphLegends}
                    id={`containerSmall_${props.InsightsElementId}`}
                    data={state}
                    color={colorPallet}
                    isEditable={
                      ROLES_MM_PRIMARY.includes(user?.UserType) && !projectIdValue?.IsFreezed
                    }
                    onChange={onChange}
                    closeMenu={closeMenu}
                    startZoomPaneClick={true}
                    onCircleClicked={onCircleClickedFunc}
                  />
                )}
              </InnerWrapper>
            )}

          </LoaderWrapper>
        </OuterWrapper>
      </ReportOuterWrapper>
    </>
  )
}

export default ReportFactorInterLinkage
